import { loginUserDetails } from "../../../components/Common/CommonFunction";
import { numberWithCommas } from "../../Report_common_function";

// ✅ Table column headers
export const columns = [
  "Item Name",
  "Rate",
  "UOM",
  "GST Type",
  "GST Percentage",
];

// ❌ Removed GST and total columns — not needed
export const PageHedercolumns = [""];


// ✅ Simplified row builder — only item data
export const Rows = (data) => {
  const returnArr = [];

  data.forEach((element) => {
    const safeFormat = (value) =>
      isNaN(value) ? "" : Number(value).toFixed(2);

    const tableItemRow = [
      element.ItemName || "",
      numberWithCommas(safeFormat(element.Rate || 0)),
      element.UnitName || "",
      element.GSTType || "",
      numberWithCommas(safeFormat(element.GSTPercentage || 0)),
    ];

    returnArr.push(tableItemRow);
  });

  return returnArr;
};


// ✅ Report header (only shows date)
export const ReportHederRows = (data) => {
  const userDetails = loginUserDetails()
  const reportArray = [
    [{ content: `${userDetails.PartyName || ''}`, styles: { halign: 'center', fontStyle: 'bold' } }],
    [{ content: `Address: ${userDetails.PartyAddress || ''}`, styles: { halign: 'left', fontStyle: 'bold' } }],
    [{ content: `${data.Date || ""}             Category: ${data.CategoryLabel || "All"}`, styles: { halign: 'left', fontStyle: 'bold' }}],
  ];

  return reportArray;
};
